'use strict';

import Backbone from 'backbone';
import config from '../../js/config';
import CartUserService from '../../services/CartUserService';
import {pluraliseAndTranslate} from '../../utilities/globalisation';
import templateBomModalList from './templates/BomModalList.hbs';
import templateBomModalListItem from './templates/BomModalListItem.hbs';

export default class BomModalList extends Backbone.View {
  get events() {
    return {
      'change .BomModal-list-applyAll .BomModal-checkbox': 'handleBomSelectAll',
      'change .BomModal-list-item .BomModal-checkbox': 'handleBomSelection'
    }
  }

  initialize() {
    this.listenTo(this.collection, 'update', this.handleBomsUpdated);
    this.listenTo(this.collection, 'change:selected', this.handleBomSelectionChanged);
    this.listenTo(this.collection, 'change:loading', this.handleBomLoadingChanged);
    this.listenTo(this.collection, 'change:success', this.handleBomSuccessChanged);
    this.listenTo(this.collection, 'change:failed', this.handleBomFailedChanged);
  }

  initializeElements() {
    this.$list = this.$('.BomModal-list-items');
    this.$tooltip = this.$('.BomModal-list-header-tooltip');
  }

  initializeTooltip() {
    if (!this.$tooltip.length) {
      return
    }

    this.$tooltip.tooltipster({
      el: this.$tooltip.get(0),
      side: 'top',
      theme: 'Tooltip'
    });
  }

  render() {
    this.$el.html(templateBomModalList({
      loggedIn: CartUserService.isUserLoggedIn(),
      bomList: this.collection.toJSON()
    }, {
      partials: { BomModalListItem: templateBomModalListItem }
    }));

    this.initializeElements();
    this.initializeTooltip();
  }

  handleBomSelectAll() {
    let applyAll = this.$('.BomModal-list-applyAll .BomModal-checkbox').is(':checked');
    this.$('.BomModal-list-item .BomModal-checkbox').prop('checked', applyAll).change();
  }

  handleBomSelection(e) {
    let model = this.collection.get(e.currentTarget.dataset.bomId);
    model.set({ selected: e.currentTarget.checked });
  }

  handleBomSelectionChanged() {
    let allSelected = this.collection.every(modal => modal.get('selected'));

    this.$('#Bom-applyAll').prop('checked', allSelected);
  }

  handleBomsUpdated(collection, event) {
    // If we are now not empty
    if (collection.length === 1) {
      this.$list.removeClass(config.classes.isEmpty);
      this.$list.empty();
    }

    if (collection.length > 1) {
      this.$('.BomModal-list-applyAll').removeClass(config.classes.uHide);
    }

    // Prepend new items
    let newItems = event.changes.added.map(model => templateBomModalListItem(model.toJSON()));
    this.$list.prepend(newItems);

    this.handleBomSelectionChanged();

    // Scroll to top
    this.$list.scrollTop(0);
  }

  getListItemByBomId(bomId) {
    return this.$(`#Bom-${bomId}`).parent();
  }

  handleBomLoadingChanged(model, isLoading) {
    let $item = this.getListItemByBomId(model.get('bomId'));
    $item.find('.Loader').toggleClass(config.classes.uHide, !isLoading);
  }

  handleBomSuccessChanged(model, isSuccess) {
    let $item = this.getListItemByBomId(model.get('bomId'));
    $item.find('.BomModal-list-item-status-success').toggleClass(config.classes.uHide, !isSuccess);
  }

  handleBomFailedChanged(model, isFailed) {
    let $item = this.getListItemByBomId(model.get('bomId'));
    $item.find('.BomModal-list-item-status-failed').toggleClass(config.classes.uHide, !isFailed);

    // Update list header text
    let count = this.collection.filter(model => model.get('failed')).length;
    let $title = this.$('.BomModal-list-header-text');
    $title.toggleClass(config.classes.hasError, !!count);
    $title.text(pluraliseAndTranslate('billOfMaterials', !!count ? 'listTitleError' : 'listTitle', { count }));
  }
}



// WEBPACK FOOTER //
// ./assets/components/BomModal/BomModalList.js